import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { tap, map } from 'rxjs/operators';
import { User } from '../models/user-modal';


const routes = {
  path: '/user-admin',
  resetPassword: `/user/reset-pwd`,
  changeStatus: (id: string) => `/user/user-change-status/${id}`,
  findChild: (id: string) => `/enterprises/child/${id}`,
  getAllEnterprises: () => `/enterprises/filter/auto-complete`,
  filterUsers: () => `/users/user-admin/search`,
  getUserById: (id: any) => `/users/user-detail/${id}`,
  updateUser: (id: any) => `/users/user-enterprise/${id}`,
  removeGroupUser: () => `/users/remove-group-user`
};

@Injectable({
  providedIn: 'root'
})
export class AsUserService {
  users: User[];

  constructor(private apiService: ApiService) {
  }

  /**
   * Get all users
   * @param filter: any
   */
  getAllUsers(filter: any) {
    return this.apiService.post('/users/user-by-enterprise/search', filter)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Get all enterprises
   */
  getAllEnterpises() {
    return this.apiService.get(routes.getAllEnterprises())
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Filter users
   */
  filterUsers(filter: any) {
    return this.apiService.post(routes.filterUsers(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  changeStatus(id: number) {
    return this.apiService.get(`/users/user-change-status/${id}`);
  }

  resetPassword(id: any) {
    return this.apiService.get(`/users/reset-password/${id}`)
      .pipe(map(res => {
        return res;
      }));
  }

  update(user: any, callBack: any, noCallBack: any) {
    return this.apiService.putAndCheckVersion(routes.updateUser(user.id), user, callBack, noCallBack);
  }

  getAllChild(id: string) {
    return this.apiService.get(routes.findChild(id)).pipe();
  }

  /**
   * Get user by id
   */
  getUser(userId: any) {
    return this.apiService.get(routes.getUserById(userId)).pipe();
  }

  removeGroupUser(userId: any) {
    return this.apiService.post(routes.removeGroupUser(), userId)
      .pipe(map(res => {
        return res;
      }));
  }
}
